<template>
  <modal type="text/x-template" id="RouterOptionsModal">
    <transition name="modal">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container">
            <div class="modal-body">
              <div class="container">
                <div @click="onClose()" class="router-container">
                  <router-link class="page" to="/">HOME</router-link>
                </div>
                <div @click="onClose()" class="router-container">
                  <router-link class="page" to="/products"
                    >PRODUCTOS</router-link
                  >
                </div>
                <div
                  v-show="getAuth"
                  @click="onClose()"
                  class="router-container"
                >
                  <router-link class="page" to="/news">NOVEDADES</router-link>
                </div>
                <div
                  v-show="getAuth"
                  @click="onClose()"
                  class="router-container"
                >
                  <router-link class="page" to="/tracking"
                    >SEGUIMIENTO</router-link
                  >
                </div>
                <div @click="onClose()" class="router-container">
                  <router-link class="page" to="/contact">CONTACTO</router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </modal>
</template>

<script>
import user_detection from "../mixins/user_detection";

export default {
  mixins: [user_detection],
  name: "RouterOptionsModal",
  props: {},
  data() {
    return {};
  },
  mounted() {},
  computed: {},
  methods: {
    onClose() {
      console.log("PASO");
      this.$store.commit("SET_SHOW_ROUTER_OPTIONS_MODAL", false);
    },
  },
  components: {},
};
</script>

<style scoped>
body {
  overflow-x: hidden;
  overflow-y: scroll !important;
}
.modal-body {
  padding: 0px;
}
.close-ing {
  cursor: pointer;
}
.container {
  width: 100%;
}
.modal-container {
  width: 100%;
}
.price {
  width: 25%;
}
.title {
  width: 75%;
}
.container-items {
  height: 65vh;
}
.page {
  padding: 0px;
}
.router-container {
  padding: 3px;
  width: min-content;
  margin-bottom: 3px;
}
</style>


// WEBPACK FOOTER //
// src/components/RouterOptionsModal.vue